import { render, staticRenderFns } from "./ExibirMensagemVeto.vue?vue&type=template&id=8afb8fb6"
import script from "./ExibirMensagemVeto.vue?vue&type=script&lang=js"
export * from "./ExibirMensagemVeto.vue?vue&type=script&lang=js"
import style0 from "./ExibirMensagemVeto.vue?vue&type=style&index=0&id=8afb8fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports